'use strict';
const angular = require('angular');

/*@ngInject*/
export class ExtrasService {
  
  TranslationService: any;

  /*@ngInject*/
  constructor(TranslationService) {
    this.TranslationService = TranslationService;
  }

  getExtraBases(extra) {
    if (extra.extraBases) {
      return extra.extraBases[this.TranslationService.getCurrentLanguage()=='en' ? 0:1];
    }
    return 0;
  }
}

export default angular.module('terrappApp.ExtrasService', [])
  .service('ExtrasService', ExtrasService)
  .name;



// WEBPACK FOOTER //
// ./client/app/services/extrasService/extrasService.service.ts